import React, { useState, useEffect } from "react";
import home from "../assets/home.png";

import logo from "../assets/logo-afp.png";
import ConnectWallet from "./ConnectWallet";
import Mint from "./Mint";
import { ethers } from "ethers";
import contractabi from "../abi/afp_abi.json";
import Links from "./Links";

function Home() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    getTotalMinted();
  }, []);

  function getTotalMinted() {
    try {
      const contractAddr = "0xa996F7F3BC647EebC98C684aB0A302c9b85d2FA1";
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const nftToken = new ethers.Contract(
        contractAddr,
        contractabi,
        provider.getSigner()
      );
      nftToken
        .totalSupply()
        .then((result) => {
          console.log("Number Minted " + result);
          setCount(result);
        })
        .catch((err) => {
          console.log(err);
        });

      //console.log("Number Minted "+ numberMinted);
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="home">
      <div className="container">
        <h1>blusteak</h1>

        <Mint></Mint>
        <Links></Links>
      </div>
    </div>
  );
}

export default Home;
